import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EventModel } from '../../models';

@Component({
    selector: 'lib-learners-event-dialog',
    templateUrl: './learners-event-dialog.component.html',
    styleUrls: ['./learners-event-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LearnersEventDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public event: EventModel) { }

}
